@if (qty) {
<product-reviews id="product-reviews"
                 [product]="parent.extendedFamilyIds"
                 [parent]="parent" />
}